webpackJsonp([37432641236680],{

/***/ 399:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>SubFire 3 Tags is an upcoming desktop application for editing ID3 tags in files and organizing them on your local file system. It is a work in progress and has not been released yet.</p>\n<p>It is currently being implemented with React and Material-UI, packaged through nw-js.</p>","frontmatter":{"path":"/SubFire3Tags","title":"SubFire 3 Tags","summary":"A Desktop ID3 Tag Editor"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---sub-fire-3-tags-8c24ab7614a946f9844c.js